import { useMutation } from "@tanstack/react-query";
import { SEND_SMS } from "./endpoints";
import { getRequest } from "./axiosClient";

export const useSendSMS = () => {
	return useMutation({
		mutationFn: ({ celular, tokenSeguridad, token }) => {
			return getRequest(
				`${SEND_SMS}?tp=1&nc=${celular}&tks=${tokenSeguridad}&tk=${token}`
			);
		},
	});
};
